import {WidgetKeyPair} from './WidgetKeyPair';

export class CrossVisionObj {
bu: string;
code: string;
dom: string;
fields: WidgetKeyPair[];
key: string;
kind: string;
level: number | null;
operation: string;
pkey: string;
shortCode: string;
vis: string;
}

